module.exports = __webpack_public_path__ + "static/media/repeat-address.3e0ff5ec.svg";